import { isString } from 'lodash';
let windowOpts = 'toolbar=0,scrollbars=1,status=1,resizable=1,location=1,menuBar=0,';
export const buildAuthWindow = (url) => {
    const windowArea = {
        width: window.outerWidth < 440 ? window.outerWidth : 440,
        height: Math.floor(window.outerHeight * 0.8),
    };

    if (windowArea.width < 360) { windowArea.width = 360; }
    if (windowArea.height < 630) { windowArea.height = 630; }
    windowArea.left = Math.floor(window.screenX + ((window.outerWidth - windowArea.width) / 2));
    windowArea.top = Math.floor(window.screenY + ((window.outerHeight - windowArea.height) / 8));

    windowOpts += `width=${windowArea.width},`;
    windowOpts += `height=${windowArea.height},`;
    windowOpts += `left=${windowArea.left},`;
    windowOpts += `top=${windowArea.top},`;

    return window.open(url, 'profileLogin', windowOpts);
};

export const sanitizeDoubleSlashOnUrl = (url) => {
    if (!isString(url)) return '';
    return url.replace(/(https?:\/\/)|(\/)+/g, '$1$2');
};
